module.exports = __webpack_public_path__ + "static/img/052挂画.7843f19.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/052挂画.jpg
// module id = EY2R
// module chunks = 0